<template>

  <div class="announcement-bar w-full border-b border-amber-300/20 bg-[linear-gradient(90deg,#040b15_0%,#0b2742_38%,#11456b_100%)] text-center text-white shadow-[0_10px_30px_rgba(0,0,0,0.18)]">
    <a href="/page/hac" class="announcement-link mx-auto inline-flex w-full items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-slate-100 transition hover:bg-white/5 hover:text-white">
      <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-3 w-3 text-amber-300" />
      <span>2027 Hac Programlarımız açıklandı.</span>
      <span class="font-bold text-amber-200 underline underline-offset-4">Detaylar</span>
    </a>
  </div>
<!-- Top promo bar (compact, modern) -->
  <div class="trust-bar w-full border-b border-brand-800 bg-gradient-to-r from-brand-900 via-brand-800 to-brand-900 text-neutral-100">
    <div class="container mx-auto max-w-screen-xl px-3 py-1.5 md:px-0 md:py-2">
      <div class="flex items-center justify-between gap-2">
        <div class="min-w-0 flex items-center gap-2 md:gap-3 text-xs">
          <span class="experience-pill inline-flex shrink-0 items-center gap-1.5 rounded-full border border-accent-300/40 bg-accent-500/15 px-2 py-1 text-accent-100">
           
            <span class="whitespace-nowrap text-neutral-100">{{$t('Umre Turlarında')}}</span>
             <strong class="text-white">21.yıl</strong>
          </span>

          <a
            v-if="topBanners[locale]?.[0]"
            class="group hidden md:inline-flex max-w-[420px] items-center gap-2 truncate rounded-full border border-white/20 bg-white/5 px-2.5 py-1 text-[11px] font-medium text-neutral-100 transition-colors hover:border-accent-300/60 hover:bg-accent-500/15"
            :href="getPath(topBanners[locale]?.[0]?.cbanner_buttonurl)"
            :title="topBanners[locale]?.[0]?.cbanner_title"
          >
            <span class="truncate">{{ topBanners[locale]?.[0]?.cbanner_title }}</span>
            <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-2.5 w-2.5 shrink-0 text-accent-200 group-hover:text-accent-100"></font-awesome-icon>
          </a>
        </div>

        <div class="flex items-center gap-2 md:gap-3">
          <a
            aria-label="Call us"
            href="tel:+908502414141"
            class="hidden md:inline-flex items-center gap-1.5 rounded-full border border-support-300/40 bg-support-600/20 px-2.5 py-1 text-[11px] font-medium text-support-100 hover:bg-support-600/30"
          >
            <font-awesome-icon icon="fa-solid fa-phone" class="h-3 w-3"></font-awesome-icon>
            <span>+90 850 241 41 41</span>
          </a> 

          <div class="language-switch inline-flex items-center overflow-hidden rounded-full border border-neutral-300/70 bg-white shadow-sm" aria-label="Language switcher">
            <button
              @click.stop.prevent="goNewLang('tr')"
              :class="locale==='tr' ? 'bg-brand-900 text-white' : 'text-neutral-700 hover:bg-neutral-100'"
              class="px-2.5 py-1 text-[11px] font-semibold transition-colors"
            >TR</button>
            <button
              @click.stop.prevent="goNewLang('en')"
              :class="locale==='en' ? 'bg-brand-900 text-white' : 'text-neutral-700 hover:bg-neutral-100'"
              class="px-2.5 py-1 text-[11px] font-semibold transition-colors"
            >EN</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main navbar -->
  <div class="main-navbar bg-white/95 backdrop-blur-sm border-b border-slate-200 shadow-sm z-40 relative">
    <div class="navbar-inner container mx-auto max-w-screen-xl flex items-center justify-between gap-4 py-1 md:py-2 px-3 md:px-0">
      <div class="flex items-center gap-4">
        <div class="logo-slot bg-white backdrop-blur">
          <div class="logo-shell bg-white rounded-b-full shadow-md">
              <a :href="locale == 'tr' ? '/' : `/${locale}`" class="logo-link flex items-center justify-center" aria-label="İnanç Tur ana sayfa">
                <img :src="('/assets/img/logo/logo.webp')" alt="İnanç Tur" class="brand-logo object-contain" />
              </a>
            </div>
        </div>
       
        <!-- compact contact / CTA on desktop -->
        <div class="hidden md:flex flex-col text-sm text-slate-600">
          <a href="tel:+908502414141" class="hover:text-slate-900">0850 241 41 41</a>
          <span class="text-xs text-slate-400 min-w-[165px] truncate">

              <span class="typewrite">Yüksek hızlı tren ile</span>
                <br class="block md:hidden" /> 
          </span>
        </div>
      </div>

      <!-- center nav links -->
      <ul class="hidden lg:flex items-center gap-2 text-sm font-medium">
        <!-- <li>
          <a href="#" ref="umrahToggle" @click="dropdownToggler('umrah')" class="flex items-center text-md truncate gap-1 px-3 py-2 rounded-md hover:bg-slate-50">
            <span>{{$t('Umre Turları')}}</span>
            <ClientOnly>
              <ChevronDownIcon :size="14" :class="dropdownNavbar['umrah'] ? 'rotate-180' : 'rotate-0'"/>
            </ClientOnly>
          </a>
        </li> -->
        <NavLink url="/tour/umre-turlari" :name="$t('Umre Turları')"  class="px-3 py-2 rounded-md hover:bg-slate-50" />
        <NavLink url="/page/hac" :name="$t('Hac')"  class="px-3 py-2 rounded-md hover:bg-slate-50" />
    
        <NavLink url="/tours/rota-yurtdisi-turlari" :name="$t('Yurtdışı Turlar')" class="px-3 py-2 rounded-md hover:bg-slate-50" />
        <NavLink url="/page/hakkimizda" :name="$t('Kurumsal')" class="px-3 py-2 rounded-md hover:bg-slate-50" />
        <NavLink url="/contact" :name="$t('İletişim')" class="px-3 py-2 rounded-md hover:bg-slate-50" />
      </ul>

      <!-- right side: actions -->
      <div class="navbar-actions flex items-center gap-3">
        <!-- quick whatsapp mobile -->
         <div class="flex flex-col text-sm text-slate-600">
            <a aria-label="WhatsApp ile iletişime geç" :href="buildWhatsAppUrl()" target="_blank" rel="nofollow noopener noreferrer" class="nav-action-btn inline-flex whatsappTrigger items-center justify-center w-9 h-9 rounded-full bg-emerald-50 border text-emerald-600">
          <font-awesome-icon icon="fa-brands fa-whatsapp" class="h-6" />
        </a>
        </div>
       <div class="flex md:hidden flex-col text-sm text-slate-600">
        <a href="tel:08502414141" aria-label="Bizi arayın" title="Telefon" class="nav-action-btn text-l rounded-full border border-slate-200 bg-slate-100 text-center items-center flex justify-center w-9 h-9">
          <svg class="svg-inline--fa fa-phone text-lg text-slate-900 mx-1" style="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="phone" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="" style="" fill="currentColor" d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"></path></svg>
          </a>
          </div>

        <!-- user / login -->
        <ClientOnly>
          <div v-if="user && user?.id" class="relative">
            <Menu as="div" class="relative">
              <MenuButton class="flex items-center gap-2 rounded-full px-2 py-1 hover:bg-slate-50">
                <div class="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-600">
                  <span class="text-sm font-medium">{{ (user.U_rname || '').charAt(0) }}</span>
                </div>
                <div class="hidden md:flex flex-col text-left">
                  <span class="text-sm font-medium text-slate-700">{{ `${user.U_rname} ${user.U_surname}` }}</span>
                  <span class="text-xs text-slate-400">Hesabım</span>
                </div>
              </MenuButton>
              <transition name="fade">
                <MenuItems class="absolute right-0 mt-2 max-h-[min(70vh,32rem)] w-64 origin-top-right overflow-y-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5">
                  <template v-for="item in visibleUserNavigation" :key="item.id">
                    <MenuItem v-slot="{ active }">
                      <a @click="item.click" class="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50">{{ item.name }}</a>
                    </MenuItem>
                  </template>
                </MenuItems>
              </transition>
            </Menu>
          </div>
          <div v-else class="hidden md:inline-flex">
            <a :href="getPath('/user/login')" @click.stop.prevent="goPath('/user/login')" class="inline-flex items-center gap-2 px-3 py-2 rounded-full border border-slate-200 bg-white text-slate-700 hover:shadow-sm">
              <font-awesome-icon icon="fa-solid fa-user" class="w-3.5 h-3.5" />
              <span class="text-sm">{{$t('Giriş / Üye Ol')}}</span>
            </a>
          </div>
        </ClientOnly>

        <!-- mobile menu button -->
        <button :aria-label="open ? 'Menüyü kapat' : 'Menüyü aç'" class="menu-toggle lg:hidden inline-flex items-center justify-center p-2 rounded-full text-slate-700 hover:bg-slate-50" @click="open = !open">
          <ClientOnly>
            <template v-if="!open"><SegmentIcon :size="24"/></template>
            <template v-else><CloseIcon :size="24"/></template>
          </ClientOnly>
        </button>
      </div>
    </div>

    <!-- Mobile collapsed content (keeps existing Teleport block behavior) -->
  </div>
   

  <div class="z-50 relative">

      <transition name="transform-fade-down">
            <div    v-show="dropdownNavbar['umrah']" class="absolute lg:top-0 w-full h-full lg:left-0">
            <div ref="megaMenu" class="mega-menu border-b  bg-[#f4f4f4] w-full pt-7">
                <div class="container">
                  <div class="lg:flex  lg:py-8">
                    <div class="w-full lg:w-2/3 md:grid md:grid-cols-3">
                      <div>
                        <h4 class="text-md font-bold mb-3">{{$t('Turlarımız')}}</h4>
                        <ul class="text-md text-dark-800">
                          <li><a :href="getPath('/tour/umre-turlari')" @click.stop.prevent="goPath('/tour/umre-turlari');dropdownNavbar['umrah']=false;">{{$t('Umre Turları')}}</a></li>
                          <li><a :href="getPath('/tour/kisiye-ozel-umre-turlari')" @click.stop.prevent="goPath('/tour/kisiye-ozel-umre-turlari');dropdownNavbar['umrah']=false;">{{$t('Kişiye Özel Umre Turları')}}</a></li>
                          <!-- <li><a :href="getPath('/tour/grup-umre-turlari')" @click.stop.prevent="goPath('/tour/grup-umre-turlari')">{{$t('Grup Umre Programları')}}</a></li> -->
                          <li><a :href="getPath('/tour/7-gunluk-umre-turlari')" @click.stop.prevent="goPath('/tour/7-gunluk-umre-turlari');dropdownNavbar['umrah']=false;">{{$t('7 Gün Umre Turları')}}</a></li>
                          <li><a :href="getPath('/tour/10-gunluk-umre-turlari')" @click.stop.prevent="goPath('/tour/10-gunluk-umre-turlari');dropdownNavbar['umrah']=false;">{{$t('10 Gün Umre Turları')}}</a></li>
                          <li><a 
                              :href="getPath('/tour/5-yildizli-luks-umre-turlari')" 
                              @click.stop.prevent="goPath('/tour/5-yildizli-luks-umre-turlari');dropdownNavbar['umrah']=false;" 
                              :title="$t('5 Yıldız Umre Turları')">
                                {{$t('5 Yıldız Umre Turları')}}
                              </a>
                          </li> 
                          <!-- <li><a :href="getPath('/tour/15-gun-umre-turlari')" @click.stop.prevent="goPath('/tour/grup-umre-turlari')">{{$t('15 Gün Umre Turları')}}</a></li> -->
                        </ul>
                      </div>
                      <div>
                        <h4 class="text-md font-bold mb-3">{{$t('Aylara Göre Umre')}}</h4>
                        <ul class="text-md text-dark-800">
                          <!-- <li><a @click="goPath('/tour/mart-umre-turlari')">Mart Umre Turları</a></li> -->
                          <!-- <li><a @click="goPath('/tour/ninsan-umre-turlari')">Nisan Umre Turları</a></li> -->
                          <!-- <li><a @click="goPath('/tour/mayis-umre-turlari')">Mayıs Umre Turları</a></li>  -->
                          <!-- <li><a @click="goPath('/tour/haziran-umre-turlari')">Haziran Umre Turları</a></li>  -->
                         <!-- <li><a :href="getPath('/tour/temmuz-umre-turlari')"  @click.stop.prevent="goPath('/tour/temmuz-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Temmuz Umre Turları')">{{$t('Temmuz Umre Turları')}}</a></li>  -->
                          <!-- <li><a :href="getPath('/tour/agustos-umre-turlari')"  @click.stop.prevent="goPath('/tour/agustos-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Ağustos Umre Turları')">{{$t('Ağustos Umre Turları')}}</a></li>  -->
                          <!-- <li><a :href="getPath('/tour/eylul-umre-turlari')"    @click.stop.prevent="goPath('/tour/eylul-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Eylül Umre Turları')" >{{$t('Eylül Umre Turları')}}</a></li>  -->
                          <li><a :href="getPath('/tour/ekim-umre-turlari')"     @click.stop.prevent="goPath('/tour/ekim-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Ekim Umre Turları')" >{{$t('Ekim Umre Turları')}}</a></li>  
                          <li><a :href="getPath('/tour/kasim-umre-turlari')"    @click.stop.prevent="goPath('/tour/kasim-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Kasim Umre Turları')">{{$t('Kasim Umre Turları')}}</a></li>
                          
                          <li><a :href="getPath('/tour/aralik-umre-turlari')"   @click.stop.prevent="goPath('/tour/aralik-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Aralik Umre Turları')">{{$t('Aralik Umre Turları')}}</a></li> 
                          <li><a :href="getPath('/tour/ocak-umre-turlari')"   @click.stop.prevent="goPath('/tour/ocak-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Ocak Umre Turları')">{{$t('Ocak Umre Turları')}}</a></li> 
                          <li><a :href="getPath('/tour/subat-umre-turlari')"   @click.stop.prevent="goPath('/tour/subat-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Şubat Umre Turları')">{{$t('Şubat Umre Turları')}}</a></li> 
                         <li><a :href="getPath('/tour/mart-umre-turlari')"   @click.stop.prevent="goPath('/tour/mart-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Mart Umre Turları')">{{$t('Mart Umre Turları')}}</a></li> 
                          <li><a :href="getPath('/tour/ramazan-umre-turlari')"   @click.stop.prevent="goPath('/tour/ramazan-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Ramazan Umre Turları')">{{$t('Ramazan Umre Turları')}}</a></li> 
                          <!-- <li><a :href="getPath('/tour/nisan-umre-turlari')"   @click.stop.prevent="goPath('/tour/nisan-umre-turlari');dropdownNavbar['umrah']=false;" :title="$t('Nisan Umre Turları')">{{$t('Nisan Umre Turları')}}</a></li>  -->
                        
                        </ul>
                      </div>
                      <div>
                        <h4 class="text-md font-bold mb-3">{{$t('Umre Hakkında')}}</h4>
                        <ul class="text-md text-dark-800">
                          <li><a class="cursor-pointer" :href="getPath('/page/umre-nedir')" @click.stop.prevent="goPath('/page/umre-nedir')">{{$t('Umre Nedir ?')}}</a></li>
                          <li><a class="cursor-pointer" :href="getPath('/page/umreye-gitme-sartlari-nelerdir')" @click.stop.prevent="goPath('/page/umreye-gitme-sartlari-nelerdir')">{{$t('Umreye Gitme Şartları')}}</a></li>
                          <li><a class="cursor-pointer" :href="getPath('/page/umre-turlari-nezaman-yapilir')" @click.stop.prevent="goPath('/page/umre-turlari-nezaman-yapilir')">{{$t('Umre Ne Zaman Yapılır ?')}}</a></li>
                          <li><a class="cursor-pointer" :href="getPath('/page/umre-hakkinda-bilinmesi-gerekenler')" @click.stop.prevent="goPath('/page/umre-hakkinda-bilinmesi-gerekenler')">{{$t('Bilinmesi Gerekenler')}}</a></li>
                          <li><a class="cursor-pointer" :href="getPath('/page/umre-fiyatlari-nasil-hesaplanir')" @click.stop.prevent="goPath('/page/umre-fiyatlari-nasil-hesaplanir')">{{$t('Umre Fiyatları Nasıl Hesaplanır ?')}}</a></li>
                        </ul>
                      </div>
                    </div>
                    <div class="w-full hidden lg:block max-w-[300px] xl:max-w-[400px] shrink-0">
                      <!-- menu add -->
                      <div class="py-10 px-5 lg:px-8 relative rounded-5xl overflow-hidden">
                        <div class="absolute top-0 left-0 w-full h-full">
                          <img src="/assets/img/kabe-sub-banner-mobile.webp" alt="umre turları" loading="lazy" class="block w-full h-full object-cover">
                        </div>
                        <div class="relative max-w-[200px]">
                          <h4 class="mb-3 text-2xl leading-[30px] lg:text-[28px]">{{$t('Umre Turları')}}</h4>
                          <p class="text-dark-900 text-md mb-5">{{$t('Turunu şimdi planla.')}}</p>
                          <a :href="getPath('/tours/yurtdisi-turlari')" @click.prevent.stop="goPath('/tours/yurtdisi-turlari')" class="btn btn-light btn-md shadow-btn mx-0">{{$t('Detaylar')}} <i class="fa-regular fa-arrow-right ml-3"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

    <Teleport to="body" :disabled="isMobile && open ? false : true">
      <div v-if="isMobile && open" class="fixed inset-0 z-[90] lg:hidden" aria-label="Mobile navigation" role="dialog" aria-modal="true">
        <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" @click="open = false"></div>

        <div class="absolute inset-y-0 right-0 w-full max-w-sm bg-white border-l border-slate-200 shadow-2xl flex flex-col" @click.stop>
          <div class="bg-gradient-to-br from-slate-900 via-slate-500 to-slate-700 px-4 pt-4 pb-5 text-white">
            <div class="flex items-center justify-between">
              <img :src="('/assets/img/logo/inanc_tur_yeni_logo.webp')" fetchpriority="high" @click="goPath('/')" class="w-28 cursor-pointer" alt="İnanç Tur Logo" />
              <button aria-label="Close menu" class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-white/10" @click="open = false">
                <font-awesome-icon icon="fa-solid fa-times" class="h-4 w-4"></font-awesome-icon>
              </button>
            </div>

            <!-- <p class="mt-4 text-xs uppercase tracking-[0.16em] text-slate-200">{{$t('Hızlı Erişim')}}</p> -->
            <div class="mt-3 grid grid-cols-2 gap-2">
              <a aria-label="whatsapp button" :href="buildWhatsAppUrl('Merhaba turlarınız hakkında bilgi almak istiyorum')" target="_blank" rel="nofollow noopener noreferrer" class="whatsappTrigger inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-500 px-3 py-2 text-sm font-medium text-white">
                <font-awesome-icon icon="fa-brands fa-whatsapp" class="h-4 w-4"></font-awesome-icon>
                <span>WhatsApp</span>
              </a>
              <a href="tel:08502414141" title="Telefon" class="inline-flex items-center justify-center gap-2 rounded-xl border border-white/30 bg-white/15 px-3 py-2 text-sm font-medium text-white">
                <font-awesome-icon icon="fa-solid fa-phone" class="h-4 w-4"></font-awesome-icon>
                <span>0850 241 41 41</span>
              </a>
            </div>
          </div>

          <div class="flex-1 overflow-y-auto bg-slate-50 px-3 py-4">
            <ul class="space-y-2">
              <li>
                <a :href="getPath('/')" @click.prevent.stop="go('/')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5">
                      <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                    </svg>
                  </span>
                  <span class="text-sm font-medium">{{$t('Anasayfa')}}</span>
                </a>
              </li>
              <li>
                <a :href="getPath('/tour/umre-turlari')" @click.prevent.stop="go('/tour/umre-turlari')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <img src="/assets/img/svg/kaaba-solid.svg" class="h-5" />
                  </span>
                  <span class="text-sm font-medium">{{$t('Umre Turları')}}</span>
                </a>
              </li>
              <li>
                <a :href="getPath('/page/hac')" @click.stop.prevent="go('/page/hac')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <img src="/assets/img/svg/kaba-icon-black-and-white.svg" class="h-5" />
                  </span>
                  <span class="text-sm font-medium">{{$t('Hac')}}</span>
                </a>
              </li>
              <li>
                <a :href="getPath('/tours/rota-yurtdisi-turlari')" @click.stop.prevent="go('/tours/rota-yurtdisi-turlari')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <img src="/assets/img/svg/luggage.svg" class="h-5" />
                  </span>
                  <span class="text-sm font-medium">{{$t('Yurtdışı Turlar')}}</span>
                </a>
              </li>
              <li>
                <a :href="getPath('/tour/kisiye-ozel-umre-turlari')" @click.stop.prevent="go('/tour/kisiye-ozel-umre-turlari')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <img src="/assets/img/svg/umrah-package.svg" class="h-5" />
                  </span>
                  <span class="text-sm font-medium">{{$t('Kişiye Özel Umre Turları')}}</span>
                </a>
              </li>
              <li>
                <a :href="getPath('/page/hakkimizda')" @click.stop.prevent="go('/page/hakkimizda')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <font-awesome-icon icon="fa-solid fa-circle" class="h-3 w-3"></font-awesome-icon>
                  </span>
                  <span class="text-sm font-medium">{{$t('Hakkımızda')}}</span>
                </a>
              </li>
              <li>
                <a :href="getPath('/contact')" @click.stop.prevent="go('/contact')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <font-awesome-icon icon="fa-solid fa-phone" class="h-4 w-4"></font-awesome-icon>
                  </span>
                  <span class="text-sm font-medium">{{$t('İletişim')}}</span>
                </a>
              </li>
              <li v-if="!user || !user.id">
                <a :href="getPath('/user/login')" @click.prevent.stop="go('/user/login')" title="Login" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5">
                      <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                    </svg>
                  </span>
                  <span class="text-sm font-medium">{{$t('Üye Ol')}}</span>
                </a>
              </li>
              <li v-if="user && user.id">
                <a :href="getPath('/user/settings')" @click.prevent.stop="go('/user/settings')" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
                    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5">
                      <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                      <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                  </span>
                  <span class="text-sm font-medium">{{$t('Ayarlar')}}</span>
                </a>
              </li>
              <li v-if="user && user.id">
                <a @click="logout(); open = false" class="group flex items-center gap-3 rounded-2xl bg-white px-4 py-3 text-slate-700 shadow-sm ring-1 ring-slate-100 transition hover:-translate-y-0.5 hover:shadow-md">
                  <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-red-50 text-red-500">
                    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5">
                      <path d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"></path>
                    </svg>
                  </span>
                  <span class="text-sm font-medium text-red-600">Logout</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="border-t border-slate-200 bg-white p-3">
            <div class="grid grid-cols-2 gap-2">
              <a target="_blank" class="inline-flex items-center justify-center gap-2 rounded-xl bg-primary-600 px-3 py-2 text-sm font-medium text-white" href="https://maps.google.com/maps/dir//%C4%B0nan%C3%A7+Turizm+Mahmutbey+Mah.+Ta%C5%9Foca%C4%9F%C4%B1+Yolu+Cad.+No:1+Polat+Tower%26Residance+kat+24+daire+188+Ba%C4%9Fc%C4%B1lar%2F%C4%B0stanbul+212+outlet+avm+biti%C5%9Fi+34714+Ba%C4%9Fc%C4%B1lar%2F%C4%B0stanbul/@41.0463828,28.8114007,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0x14cab86f3f379145:0xa7939b402ce4764b">
                <font-awesome-icon icon="fa-solid fa-map-marker" class="h-4 w-4"></font-awesome-icon>
                <span>{{$t('Yol Tarifi Al')}}</span>
              </a>
              <a href="tel:08502414141" title="Ara" class="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700">
                <font-awesome-icon class="h-4 w-4 text-slate-500" icon="fa-solid fa-phone"></font-awesome-icon>
                <span>0850 241 41 41</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Teleport>


    <div class="relative z-40" v-if="alert.show" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div class="fixed inset-0 z-50 overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
            <div>
              <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100"
                v-if="alert.type == 'success'">
                <!-- Heroicon name: outline/check -->
                <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </div>
              <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-orange-100"
                v-else-if="alert.type == 'warning'">
                <!-- Heroicon name: outline/check -->
                <svg class="h-6 w-6 text-orange-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                </svg>
              </div>
              <div class="mt-3 text-center sm:mt-5">
                <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">{{ alert.title }}</h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">{{ alert.text }}</p>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-6">
              <button type="button" @click="closeAlert();"
                class="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm">
                Kapat
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
 
</template>
<script setup> 
import { computed, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import Cookies from 'js-cookie';
import { buildWhatsAppUrl } from '~/utils/whatsapp'
import { accountingHeaderMenuOptions, canUseAccountingHeaderMenu, parseAccountingHeaderMenu } from '~/utils/accountingHeaderMenu'
import {
  Menu, MenuButton, MenuItem, MenuItems
} from '@headlessui/vue' 
// const { $socket } = useNuxtApp(); 
defineOptions({ name: 'BaseNavbar' })

const route = useRoute();
const alert = useAlert();
const open = ref(false)
const megaMenu = ref(null)
const umrahToggle = ref(null)
const dropdownNavbar = reactive({
  umrah: false,
  outgoing: false
})

const closeAlert = () => {
  alert.value = {
    show: false,
    title: '',
    text: '',
    type: ''
  }
};

const { locale,  setLocale } = useI18n()
const {goPath,getPath, logout, setHeadMeta} = useCommon()
const isMobile = useIsMobile();
const user = useUser()
const headerUse = useHeader() 

setHeadMeta(); 

const dropdownToggler = (type) => {
  setTimeout(() => {
    dropdownNavbar[type] = !dropdownNavbar[type]
  }, 400)
}

const handleDocumentClick = (e) => {
  if (!dropdownNavbar.umrah) return

  if (megaMenu.value && megaMenu.value.contains(e.target)) return
  if (umrahToggle.value && umrahToggle.value.contains(e.target)) return

  dropdownNavbar.umrah = false
}

onMounted(() => {
  document.addEventListener('click', handleDocumentClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick)
})

const goNewLang = async (lang)=>{
 await setLocale(lang);
  goPath("/"); 
}
 
// const openNoteForm = inject("openNoteForm")


const userNavigation = [
    { 
      id: 'my-reservations',
      name: 'Rezervasyonlarım',  
      isCustomer:true, 
      click: ()=>{ 
      useGoPath("/user/home");
      }
    },
    { 
      id: 'admin-dashboard',
      name: 'Dashboard', 
      isAdmin:true, 
      click: ()=>{ 
        useGoPath("/admin/dashboard");
      }
    },
    { 
      id: 'agent-dashboard',
      name: 'Dashboard',  
      isAgent:true,
      click: ()=>{ 
        useGoPath("/agent/dashboard");
      }
    },
    { 
      id: 'customer-notes',
      name: 'Müşteri Notları', 
      isAdmin:true,
      click: ()=>{ 
        useGoPath("/admin/notes");
      }
    },
    { 
      id: 'accounting',
      name: 'Muhasebe', 
      isAdmin:true,
      role: 'accounting',
      click: ()=>{ 
        useGoPath("/admin/accounting");
      }
    },
    { 
      id: 'admin-offers',
      name: 'Teklifler', 
      isAdmin:true,
       isAgent:true,
      click: ()=>{ 
        useGoPath("/admin/offer");
      }
    },
    { 
      id: 'admin-reservations',
      name: 'Rezervasyonlar', 
      isAdmin:true,
      click: ()=>{ 
        useGoPath("/admin/reservations");
      }
    },
    { 
      id: 'agent-offers',
      name: 'Teklifler',  
      isAgent:true,
      click: ()=>{ 
        useGoPath("/agent/offer");
      }
    },
    { 
      id: 'agent-reservations',
      name: 'Rezervasyonlar',  
      isAgent:true,
      click: ()=>{ 
        useGoPath("/agent/reservations");
      }
    },
    { 
      id: 'operations',
      name: 'Operasyon', 
      isAdmin:true,
      click: ()=>{ 
        useGoPath("/admin/availability");
      }
    },
    { 
      id: 'settings',
      name: 'Ayarlar',
      isAllUsers: true,
      click: ()=>{  
        useGoPath("/user/settings");
    }},
    { id: 'logout', name: ('Çıkış Yap'),
    isAllUsers: true,
      click: ()=>{
        logout();
      }
    },
  ];

const isVisibleNavigationItem = (item) => {
  if (!user.value?.id) return false
  if (item.isAllUsers) return true
  if (user.value.U_Admin === 'on' && item.role && askRole(item.role)) return true
  if (user.value.U_Admin === 'on' && item.isAdmin && !item.role) return true
  if (!item.isAdmin && user.value.U_Role === 'Customer' && item.isCustomer) return true
  return user.value.U_Role === 'Agent' && item.isAgent
}

const visibleUserNavigation = computed(() => {
  const baseItems = userNavigation.filter(isVisibleNavigationItem)
  if (!canUseAccountingHeaderMenu(user.value)) return baseItems

  const enabledShortcuts = new Set(parseAccountingHeaderMenu(user.value.U_HeaderMenu))
  const accountingShortcuts = accountingHeaderMenuOptions
    .filter((item) => enabledShortcuts.has(item.id))
    .map((item) => ({
      ...item,
      name: item.label,
      click: () => goPath(item.path),
    }))

  const accountingIndex = baseItems.findIndex((item) => item.id === 'accounting')
  if (accountingIndex < 0 || !accountingShortcuts.length) return baseItems
  return [
    ...baseItems.slice(0, accountingIndex + 1),
    ...accountingShortcuts,
    ...baseItems.slice(accountingIndex + 1),
  ]
})



const setUseHeader = () => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json;charset=UTF-8"
  }

  const token = process.client ? Cookies.get('token') : null
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  headerUse.value = headers;
}
setUseHeader();


// onMounted(()=>{
 
//   if(user?.value?.U_Admin === 'on'){
//     $socket.emit('join-admin'); 
//     // Gelen çağrıları dinle
//     $socket.on('call-event', (callData) => {

//       console.log("callData",callData);
//       if(callData.type=="ringing"){

//       }else{
//         console.log('Yeni arama:', callData);
//         let data = {
//               not_ad: `${callData.pers_firstname} ${callData.pers_lastname} `,
//               not_konu: 'ARAMA',
//               not_cep:callData.call_number,
//               not_email: callData.pers_email,
//               message:'',
//               id: null
//         };
//         openNoteForm(null,data);
//       }
  
//     });
//   }
   
// })

const go = (link)=>{
  open.value = false
  goPath(link)
}

const topBanners = {

  en:[
  {
    cbanner_bgcolor: 'rgb(223 171 47)',
    cbanner_title: 'Umrah Packages 2026',
    cbanner_buttontext: 'Go',
    cbanner_buttonurl: 'https://inanctur.com.tr/en/tour/umrah-tours',
    cbanner_buttonvariant: 'primary',
    cbanner_buttoncolor: 'orange',
  }
  ],
  tr:[
  {
    cbanner_bgcolor: 'rgb(223 171 47)',
    cbanner_title: 'Umre Turları 2026',
    cbanner_buttontext: 'İncele',
    cbanner_buttonurl: 'https://inanctur.com.tr/tour/umre-turlari',
    cbanner_buttonvariant: 'slate',
    cbanner_buttoncolor: 'slate',
  }
  ]


  // {
  //   cbanner_bgcolor: 'rgb(67 59 59)',
  //   cbanner_title: 'YARIYIL TATİLİ UMRE TURLARI',
  //   cbanner_buttontext: 'Detaylar',
  //   cbanner_buttonurl: 'https://inanctur.com.tr/tour/umre-turlari?duration=&when=01-25',
  //   cbanner_buttonvariant: 'primary',
  //   cbanner_buttoncolor: 'orange',
  // }
 
}

watch(() => route.fullPath, () => { 
  open.value = false;
  setHeadMeta(); 
})
</script>

<style scoped>
.logo-slot {
  width: 164px;
  height: 76px;
}

.logo-shell {
  display: flex;
  width: 164px;
  height: 76px;
  margin-top: 0;
  padding: 0.2rem 0.75rem 0.35rem;
  align-items: center;
  border-radius: 0 0 2rem 2rem;
  box-shadow: 0 14px 28px -19px rgba(15, 23, 42, 0.62);
}

.logo-link {
  width: 100%;
  height: 100%;
}

.brand-logo {
  width: 146px;
  height: 70px;
}

@media (max-width: 767px) {
  .announcement-link {
    min-height: 36px;
    padding: 0.4rem 0.75rem;
    gap: 0.45rem;
    font-size: 0.72rem;
    line-height: 1.15;
  }

  .announcement-link svg {
    width: 0.55rem;
    height: 0.55rem;
  }

  .trust-bar .container {
    padding-top: 0.35rem;
    padding-bottom: 0.35rem;
  }

  .experience-pill {
    border-color: rgba(225, 185, 104, 0.34);
    background: rgba(180, 122, 22, 0.12);
    padding: 0.3rem 0.6rem;
    font-size: 0.7rem;
  }

  .language-switch button {
    min-width: 38px;
    min-height: 28px;
    padding: 0.25rem 0.6rem;
    font-size: 0.68rem;
  }

  .navbar-inner {
    min-height: 80px;
    padding: 0.3rem 0.75rem;
    gap: 0.25rem;
  }

  .logo-slot {
    width: 148px;
    height: 68px;
  }

  .logo-shell {
    display: flex;
    width: 148px;
    height: 68px;
    margin-top: 0;
    padding: 0.15rem 0.45rem 0.35rem;
    align-items: center;
    border-radius: 0 0 1.5rem 1.5rem;
    box-shadow: 0 12px 24px -18px rgba(15, 23, 42, 0.65);
  }

  .brand-logo {
    width: 136px;
    height: 64px;
  }

  .navbar-actions {
    gap: 0.45rem;
  }

  .nav-action-btn,
  .menu-toggle {
    width: 40px;
    height: 40px;
    margin: 0;
  }

  .nav-action-btn {
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72);
  }
}
</style>
